import { IDepartment, IDepartmentManager, IDepartmentTeam } from 'types/income';
import {
  Department,
  DepartmentManager,
  DepartmentTeam,
} from './departments.types';
import { loaders } from './departments.loaders';

const convertDepartmentManager = (
  manager?: IDepartmentManager,
): DepartmentManager | null => {
  return manager
    ? {
        id: manager.id,
        name: manager.name,
      }
    : null;
};

const convertDepartmentTeam = (team: IDepartmentTeam): DepartmentTeam => {
  return {
    id: team.id,
    name: team.name,
    externalId: team.externalId,
    departmentId: team.departmentId,
    hidden: team.hidden,
    companyExternalId: team.companyExternalId,
    manager: convertDepartmentManager(team.manager),
    isEmpty: team.isEmpty,
  };
};

const convertDepartment = (department: IDepartment): Department => {
  return {
    id: department.id,
    name: department.name,
    hidden: department.hidden,
    isEmpty: department.isEmpty,
    companyId: department.companyId,
    companyName: department.companyName,
    manager: convertDepartmentManager(department.manager),
    teams: department.teams?.map(convertDepartmentTeam) ?? [],
  };
};

const convertDepartments = (departments: IDepartment[]): Department[] => {
  return departments.map(convertDepartment);
};

export const converters = {
  getDepartments: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getDepartments>>) => {
    return convertDepartments(data.data);
  },
};
